import TableComponent from '../../../Common/Charts/TableCharts';
import { number } from '../../../Common/Util/number';
import { useDetailsChartsDataContext } from './hooks/useDetailsChartsDataContext';
import { useSanitizeData } from '../../Common/hooks/useSanitizeData';

export const ConductAnualList = () => {
    const { chartData } = useDetailsChartsDataContext();

    const tableColumns = [
            {
                key: 'ano_registro_bo',
                header: 'Ano',
                headerStyle: { fontWeight: '700' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'desc_conduta',
                header: 'Conduta',
                headerStyle: { fontWeight: '700' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'total',
                header: 'Total',
                headerStyle: { fontWeight: '700', textAlign: 'right' },
                cellStyle: { textAlign: 'right', fontWeight: '400' },
                formatter: (value) => number.formatToBRNumber(value)
            }
    ];

    const rawData = chartData?.conductEvolutionAnual || [];

    const flattenedData = rawData.flatMap((itemAno) => {
        return itemAno.condutas.map((desc_conduta) => ({
            ...desc_conduta,
            ano_registro_bo: itemAno.ano_registro_bo
        }));
    });

    const sanitizedData = useSanitizeData(flattenedData);

    return (
        <div style={{ width: '100%' }}>
            <TableComponent
                data={sanitizedData}
                columns={tableColumns}
                title="Condutas Anuais"
                showTotal={true}
                totalColumn="total"
                formatNumber={number.formatToBRNumber}
                maxHeight="600px"
            />
        </div>
    );
};